import styled from 'styled-components';
import { DEAD_ZONE_SIZE, SIDEBAR_DEADZONE_Z_INDEX } from '../constants/SidebarConstants';
const CollapsableSidebarHeaderDeadZone = styled.div.withConfig({
  displayName: "CollapsableSidebarHeaderDeadZone",
  componentId: "sc-1kyasgp-0"
})(["position:absolute;z-index:", ";width:100%;height:", "px;cursor:pointer;"], SIDEBAR_DEADZONE_Z_INDEX, DEAD_ZONE_SIZE);
export default CollapsableSidebarHeaderDeadZone;